import { CommonModule } from '@angular/common';
import { A11yModule } from '@angular/cdk/a11y';
import { NgModule } from '@angular/core';
import { SignupComponent } from '@dashboard/app/components/signup/signup.component';
import { EmailAndPasswordFormComponent } from '@dashboard/app/components/signup/email-and-password-form/email-and-password-form.component';
import { LTIConfirmationComponent } from '@dashboard/app/components/signup/lti-confirmation/lti-confirmation.component';
import { OrgSearchComponent } from '@dashboard/app/components/signup/org-search/org-search.component';
import { OrgCreateComponent } from '@dashboard/app/components/signup/org-create/org-create.component';
import { AccountCreateComponent } from '@dashboard/app/components/signup/account-create/account-create.component';
import { StudentSignupMessageComponent } from '@dashboard/app/components/signup/student-signup-message/student-signup-message.component';
import { GoStepperModule } from '@dashboard/app/components/go-stepper/go-stepper.module';
import { EmailVerificationModule } from '@go-modules/components/email-verification/email-verification.module';
import { AuthTemplateModule } from '@go-modules/components/auth-template/auth-template.module';
import { GoLogoModule } from '@dashboard/app/components/go-logo/go-logo.module';
import { TranslateModule } from '@ngx-translate/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { GoMaterialModule } from '@go-modules/go-material.module';
import { FocusOnFirstInvalidFieldModule } from '@go-modules/directives/focus-on-first-invalid-field';
import { TrackByPropPipeModule } from '@go-modules/pipes/track-by-prop/track-by-prop-pipe.module';
import { UserTypeSelectionDialogModule } from '@go-modules/components/dialogs/user-type-selection-dialog/user-type-selection-dialog.module';
import { SsoProviderButtonModule } from '@go-modules/components/sso-provider-button/sso-provider-button.module';
import { PasswordVisibilityToggleModule } from '@go-modules/directives/password-visibility-toggle/password-visibility-toggle.module';
import {
	PasswordRequirementsModule
} from '@go-modules/directives/password-requirements/password-requirements.module';
import { MatTooltipModule } from '@angular/material/tooltip';
import { GoCdkPopoverDirective } from '@go-modules/directives/go-cdk-popover/go-cdk-popover.directive';
import { RequiredFieldsNoteDirective } from '@go-modules/directives/required-fields-note';

@NgModule({
	imports: [
		A11yModule,
		CommonModule,
		TranslateModule,
		FormsModule,
		ReactiveFormsModule,
		GoMaterialModule,
		GoStepperModule,
		GoCdkPopoverDirective,
		MatTooltipModule,
		FocusOnFirstInvalidFieldModule,
		EmailVerificationModule,
		AuthTemplateModule,
		TrackByPropPipeModule,
		GoLogoModule,
		SsoProviderButtonModule,
		UserTypeSelectionDialogModule,
		PasswordVisibilityToggleModule,
		PasswordRequirementsModule,
		RequiredFieldsNoteDirective
	],
	declarations: [
		SignupComponent,
		EmailAndPasswordFormComponent,
		LTIConfirmationComponent,
		OrgSearchComponent,
		OrgCreateComponent,
		AccountCreateComponent,
		StudentSignupMessageComponent
	],
	exports: [
		SignupComponent,
		EmailAndPasswordFormComponent,
		LTIConfirmationComponent,
		OrgSearchComponent,
		OrgCreateComponent,
		AccountCreateComponent,
		StudentSignupMessageComponent
	]
})
export class SignupModule {}
